const AUDIO_CAPTION_TITLE = /^audio#caption\b/i;
const LEGACY_AUDIO_NOTE_TITLE = /^from audio #\d+$/i;

export const isAudioCaptionNoteTitle = (title) => {
  const value = String(title || '').trim();
  if (!value) return false;
  return AUDIO_CAPTION_TITLE.test(value) || LEGACY_AUDIO_NOTE_TITLE.test(value);
};
